"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createId = _interopRequireDefault(require("../../utils/createId"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/tooltip/index.css");

  require("../../spectrum-css/tooltip/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/tooltip/index-lg.css");
} else {
  require("../../spectrum-css/tooltip/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/tooltip/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/tooltip/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/tooltip/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/tooltip/multiStops/darkest.css");

var Tooltip =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Tooltip, _Component);

  function Tooltip(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Tooltip);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Tooltip).call(this, props, context));
    _this.tooltipId = (0, _createId["default"])();
    return _this;
  }

  (0, _createClass2["default"])(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          variant = _this$props.variant,
          children = _this$props.children,
          arrowStyle = _this$props.arrowStyle,
          className = _this$props.className,
          placement = _this$props.placement,
          open = _this$props.open,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.tooltipId : _this$props$id,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["variant", "children", "arrowStyle", "className", "placement", "open", "id"]);
      return _react["default"].createElement("span", (0, _extends2["default"])({
        className: (0, _classnames["default"])('spectrum-Tooltip', "spectrum-Tooltip--".concat(variant), "spectrum-Tooltip--".concat(placement.split(' ')[0]), {
          'is-open': open
        }, className),
        id: id
      }, (0, _filterDOMProps["default"])(otherProps)), _react["default"].createElement("span", {
        className: "spectrum-Tooltip-label"
      }, children), _react["default"].createElement("span", {
        className: "spectrum-Tooltip-tip",
        style: arrowStyle
      }));
    }
  }]);
  return Tooltip;
}(_react.Component);

exports["default"] = Tooltip;
(0, _defineProperty2["default"])(Tooltip, "propTypes", {
  /**
   * The placement of the tooltip.
   */
  placement: _propTypes["default"].oneOf(['bottom', 'top', 'left', 'right']),

  /**
   * The variant will affect color.
   */
  variant: _propTypes["default"].oneOf(['inspect', 'info', 'success', 'error']),

  /**
   * The class name of the tooltip.
   */
  className: _propTypes["default"].string,

  /**
   * The ID of the tooltip.
   */
  id: _propTypes["default"].string,

  /**
   * The WAI-ARIA role for the tooltip
   */
  role: _propTypes["default"].oneOf(['tooltip']),

  /**
   * Control if the tooltip should be opened or not.
   */
  open: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Tooltip, "defaultProps", {
  variant: 'inspect',
  placement: 'right',
  open: true,
  role: 'tooltip'
});